module.exports = __webpack_public_path__ + "img/07Jackson.3677282c.png";